'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/26.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _beautifulServices = require('redux/modules/beautifulServices');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BeautifulServices = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    promises.push(dispatch((0, _beautifulServices.load)(location.query)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.beautifulServices.data,
    dataError: state.beautifulServices.error
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BeautifulServices, _Component);

  function BeautifulServices() {
    (0, _classCallCheck3.default)(this, BeautifulServices);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(BeautifulServices).call(this));
  }

  (0, _createClass3.default)(BeautifulServices, [{
    key: 'onItemClick',
    value: function onItemClick(val) {
      var _props = this.props;
      var dispatch = _props.dispatch;
      var data = _props.data;
      var location = _props.location;

      if (dispatch) {
        dispatch((0, _beautifulServices.load)(data.products.type, location.query, val));
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props2 = this.props;
      var dispatch = _props2.dispatch;
      var location = _props2.location;

      if (dispatch) {
        dispatch((0, _reactRouterRedux.push)({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) }));
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props3 = this.props;
      var dispatch = _props3.dispatch;
      var data = _props3.data;
      var location = _props3.location;

      if (dispatch) {
        dispatch((0, _beautifulServices.load)(data.products.type, location.query, '', val));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var styles = require('./BeautifulServices.scss');
      var productDiv = '';
      var carouselDiv = '';
      var totalPageNumber = 1;
      if (data) {
        var listOfBeautifulService = data.listOfBeautifulService;
        var listOfBeautifulServiceError = data.listOfBeautifulServiceError;
        var listOfBeautifulServiceRecordCount = data.listOfBeautifulServiceRecordCount;
        var listOfBeautifulServicePagesize = data.listOfBeautifulServicePagesize;
        var carouselOfBeautifulService = data.carouselOfBeautifulService;
        var carouselOfBeautifulServiceError = data.carouselOfBeautifulServiceError;

        if (carouselOfBeautifulServiceError) {
          carouselDiv = '错误：' + carouselOfBeautifulServiceError;
        } else if (carouselOfBeautifulService instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: carouselOfBeautifulService });
        }
        if (listOfBeautifulServiceError) {
          productDiv = _react2.default.createElement(
            'div',
            null,
            listOfBeautifulServiceError
          );
        } else {
          productDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            listOfBeautifulService instanceof Array ? listOfBeautifulService.map(function (info, index) {
              return _react2.default.createElement(_components.BeautifulItemInfo, { key: info.id, index: index, info: info });
            }) : ''
          );
        }
        totalPageNumber = parseInt(listOfBeautifulServiceRecordCount / listOfBeautifulServicePagesize, 10);
        if (listOfBeautifulServiceRecordCount % listOfBeautifulServicePagesize > 0) {
          ++totalPageNumber;
        }
      }
      // const filterArray = [{text: '综合排序'}, {text: '人气'}, {text: '销量'}, {text: '信用'}];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'ul',
          { className: styles.op },
          _react2.default.createElement(
            'li',
            { className: 'ml0' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/servicesmarket' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/yfw/ab1.jpg' })
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/servicesmarket' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/yfw/ab2.jpg' })
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/servicesmarket' },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/yfw/ab3.jpg' })
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: 'clear' }),
        productDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber, onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return BeautifulServices;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  productsError: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = BeautifulServices;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/BeautifulServices/BeautifulServices.js
 ** module id = 1445
 ** module chunks = 0
 **/